import {
  sendNotification,
  useEntityMetadataIncludeExternal,
  useFormBaseMetadata,
  useModuleFederationContext,
  useTranslation,
} from '@msdk/common'
import { EntityMetadata } from '@msdk/definitions'
import { createComponentWrapperWithRef, styled } from '@msdk/ui'
import React, { useEffect, useState } from 'react'

interface Props {
  entityName: string
  formName: string
  children: React.ReactElement
}

const MuiStyledWrapper = styled('div')`
  padding-right: 24px;
`

const NovaStyledWrapper = styled('div')`
  padding-right: 24px;
`

const StyledWrapper = createComponentWrapperWithRef(
  {
    mui: MuiStyledWrapper,
    nova: NovaStyledWrapper,
  },
  'StyledWrapper',
)

export function EmbeddedFormFederationWrapper(props: Props) {
  const { ensureModule, loadedModules } = useModuleFederationContext()
  const entityModel = useEntityMetadataIncludeExternal(props.entityName, props.formName)
  const baseMetadata = useFormBaseMetadata(props.entityName, props.formName) as EntityMetadata | undefined
  const [msOK, setMsOk] = useState(false)
  const t = useTranslation()

  useEffect(() => {
    if (baseMetadata) {
      ensureModule(props.entityName, props.formName, baseMetadata.msProvider, entityModel, true)
      setMsOk(true)
    } else {
      setMsOk(false)
      sendNotification({
        message: t('NOT_FOUND_MS_METADATA_ERROR', 'Some data was not able to be loaded, a microservice is missing'),
        status: 'error',
      })
    }
  }, [])

  const isModuleLoaded = baseMetadata ? !!loadedModules[baseMetadata.msProvider] : false

  return <StyledWrapper>{isModuleLoaded && msOK && props.children}</StyledWrapper>
}
